import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { PageBlueprint } from '@backstage/frontend-plugin-api';

const errorReportingPage = PageBlueprint.make({
  name: 'error-reporting',
  params: {
    path: '/error-reporting',
    title: 'Error Reporting',
    loader: () =>
      import('./ErrorReportingPage').then(m => <m.ErrorReportingPage />),
  },
});

export const errorReportingModule = createFrontendModule({
  pluginId: 'app',
  extensions: [errorReportingPage],
});
